import { render, staticRenderFns } from "./item-common.vue?vue&type=template&id=8daaa13c&scoped=true"
import script from "./item-common.vue?vue&type=script&lang=js"
export * from "./item-common.vue?vue&type=script&lang=js"
import style0 from "./item-common.vue?vue&type=style&index=0&id=8daaa13c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daaa13c",
  null
  
)

export default component.exports